import { call, put, takeEvery } from "redux-saga/effects"
import { FETCH_WASTE_DATA, DELETE_WASTE_DATA } from "./actionTypes"
import { fetchWasteSuccess, fetchWasteFailure } from "./actions"
import axios from "axios"

function* fetchWasteDataSaga() {
  try {
    const token = localStorage.getItem("authToken")
    const response = yield call(
      axios.get,
      process.env.REACT_APP_WEB_APP_URL + "/api/web/waste-load-types",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    yield put(fetchWasteSuccess(response.data))
  } catch (error) {
    yield put(fetchWasteFailure({ error: error.message }))
  }
}

export default function* WasteSaga() {
  yield takeEvery(FETCH_WASTE_DATA, fetchWasteDataSaga)
}
